import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function Radio(props) {
  const {
    name, label, value, isChecked, disabled, handleChange,noPadding, ariaLabel
  } = props;
  const { t } = useTranslation();

  const handleKeyPress = (e) => {
    e.preventDefault();
    const charCode = typeof e.which === "undefined" ? e.keyCode : e.which;
    if (charCode === 13) {
      handleChange(value);
    }
  };

  return (
    <Form.Check
      key={name}
      type="radio"
      className={noPadding ? 'form-check-radio noPadding' :'form-check-radio'}
      label={t(label)}
    >
      
      <div
        className="form-check-radio-container"
        role="radio"
        tabIndex={0}
        onClick={() => handleChange(value)}
        onKeyPress={handleKeyPress}
        aria-label={ariaLabel? t(ariaLabel) :t(label)}
        aria-checked={isChecked}
      >
        <Form.Check.Input
          type="radio"
          name={name}
          id={name}
          checked={isChecked}
          disabled={disabled}
          onChange={() => handleChange(value)}
        />
        <span className="after-input" />
        <Form.Check.Label className="form-check-radio-label">
          {t(label)}
        </Form.Check.Label>
      </div>
    </Form.Check>
  );
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  isChecked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ariaLabel:PropTypes.string
};

Radio.defaultProps = {
  disabled: false,
};

export default Radio;
